import {createQueryParameters, to_url} from "../_helpers/utils";
import {Api, apiFetch} from "../_helpers/api";
import {GeoState} from "../_definitions/styleteq";
import {SearchRoutes} from "../routes";
declare const fetch;

const SearchRepository = {
    search: (q: string, geo: GeoState, typeFilter: string, secondaryFilters: string[], page: number, perPage: number = 25) => {
        return apiFetch(to_url(Api.apiBaseUrl, 'search') + SearchRoutes.queryUrl(q, geo, typeFilter, secondaryFilters, page, perPage))
            .then(response => {
                return response.json();
            });
    },
    searchTrendingCategory: (typeFilter: string, geo: GeoState, perPage: number, secondaryFilters: string[]) => {
        return SearchRepository.search(null, geo, typeFilter, secondaryFilters, null, perPage);
    },
};

export default SearchRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/searchRepository.ts